import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/pin-off.vue
var s = {
	name: "DtIconPinOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--pin-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Pin Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M3.446 1a.5.5 0 0 1 .5-.5H8a1.5 1.5 0 0 1 0 3v1.17a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5H8a.5.5 0 0 0 0-1H3.946a.5.5 0 0 1-.5-.5ZM.647.647a.5.5 0 0 1 .707 0l10 10a.5.5 0 1 1-.707.707L8.293 9H6.5v2a.5.5 0 1 1-1 0V9h-3a.5.5 0 0 1-.5-.5v-.88a1.5 1.5 0 0 1 .831-1.342l.892-.45A.5.5 0 0 0 4 5.38v-.673L.647 1.354a.5.5 0 0 1 0-.707Zm3.522 6.075a1.5 1.5 0 0 0 .801-1.045L7.293 8H3v-.38a.5.5 0 0 1 .278-.447l.891-.451Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=pin-off.js.map